import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import MasterPage from "../master-page";
import { getMaterials } from "../../actions/portal.action";
import localizationService from "../../services/localization-service";
import MoonLoader from "react-spinners/MoonLoader";

export const MaterialsPage = () => {
  const dispatch = useDispatch();
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [expandedWeek, setExpandedWeek] = useState(0);
  const weeks = useSelector((state) => state.portal.materials);
  const selectedlang = useSelector((state) => state.account.lang);
  const materialsLoading = useSelector(
    (state) => state.portal.materialsLoading
  );

  useEffect(() => {
    dispatch(getMaterials(selectedlang));
  }, [dispatch]);

  const onClick = (item) => {
    window.open(
      process.env.REACT_APP_API_ROOT.replace("/api/client", "") + item.FileUrl,
      "_blank"
    );
  };

  const toggleWeek = (index) => {
    setSelectedFolder(null);
    setExpandedWeek(expandedWeek === index ? -1 : index);
  };

  return (
    <MasterPage>
      <div className="space-y-6">
        {/* Loading Overlay */}
        {materialsLoading && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 transition-opacity duration-300">
            <MoonLoader
              color="#9aa82d"
              size={80}
              loading={materialsLoading}
              aria-label="Loading Spinner"
            />
          </div>
        )}

        {/* Materials List */}
        {weeks.MaterialsByWeek && weeks.MaterialsByWeek.length === 0 ? (
          <div className="bg-white rounded-2xl shadow-xl p-4 sm:p-8">
            <div className="flex items-center p-4 bg-yellow-50 border-l-4 border-yellow-400 rounded-lg">
              <div className="flex-shrink-0">
                <i className="fas fa-exclamation-triangle text-yellow-400"></i>
              </div>
              <div className="ml-3">
                <p className="text-sm text-yellow-700">
                  {localizationService.getLocalizationValue(
                    "noMaterials",
                    selectedlang
                  )}
                </p>
              </div>
            </div>
          </div>
        ) : (
          <div className="space-y-4">
            {weeks.MaterialsByWeek &&
              weeks.MaterialsByWeek.map((w, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-200"
                >
                  <div className="border-b border-gray-200">
                    <button
                      className={`w-full px-3 sm:px-6 py-3 sm:py-4 flex items-center justify-between text-left focus:outline-none transition-colors duration-150 ${
                        expandedWeek === index
                          ? "bg-[#98a62d] text-white hover:bg-[#7d8a1f]"
                          : "hover:bg-gray-50 text-gray-900"
                      }`}
                      onClick={() => toggleWeek(index)}
                      aria-expanded={expandedWeek === index}
                    >
                      <h3
                        className={`text-base sm:text-lg font-medium ${
                          expandedWeek === index
                            ? "text-white"
                            : "text-gray-900"
                        }`}
                      >
                        {w.WeekName}
                      </h3>
                      <i
                        className={`fas fa-chevron-down transform transition-transform duration-200 ${
                          expandedWeek === index
                            ? "rotate-180 text-white"
                            : "text-gray-400"
                        }`}
                      ></i>
                    </button>
                  </div>

                  <div
                    className={`transition-all duration-200 ease-in-out ${
                      expandedWeek === index
                        ? "max-h-[2000px] opacity-100"
                        : "max-h-0 opacity-0"
                    } overflow-hidden`}
                  >
                    <div className="p-4 sm:p-6">
                      {selectedFolder !== null ? (
                        <div className="space-y-4">
                          <button
                            className="inline-flex items-center px-3 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors duration-200"
                            onClick={() => setSelectedFolder(null)}
                          >
                            <i className="fas fa-arrow-left mr-2"></i>
                            {localizationService.getLocalizationValue(
                              "backBtn",
                              selectedlang
                            )}
                          </button>

                          <div className="space-y-3">
                            {selectedFolder.map((f, numFolder) => (
                              <div
                                key={numFolder}
                                className="sm:flex sm:items-center sm:justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-200"
                              >
                                <div className="flex items-center space-x-3 mb-3 sm:mb-0">
                                  <i
                                    className={`fas ${
                                      f.Ext === ".pdf"
                                        ? "fa-file-pdf text-red-500"
                                        : f.Ext === ".pptx"
                                        ? "fa-file-powerpoint text-orange-500"
                                        : f.Ext === ".doc" || f.Ext === ".docx"
                                        ? "fa-file-word text-blue-500"
                                        : "fa-file-image text-green-500"
                                    } text-xl`}
                                  ></i>
                                  <div className="min-w-0 flex-1">
                                    <div className="font-medium text-gray-900 truncate">
                                      {f.Title}
                                    </div>
                                    <div className="text-sm text-gray-500">
                                      {f.CreatedDate} • {f.FileSize} MB
                                    </div>
                                  </div>
                                </div>
                                <div className="flex justify-end">
                                  <button
                                    onClick={() => onClick(f)}
                                    className="w-full sm:w-auto inline-flex items-center justify-center px-3 py-2 text-sm font-medium text-white bg-[#9aa82d] hover:bg-[#7d8a1f] rounded-md transition-colors duration-200"
                                  >
                                    <i className="fas fa-download mr-2"></i>
                                    {localizationService.getLocalizationValue(
                                      "download",
                                      selectedlang
                                    )}
                                  </button>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : (
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                          {w.MaterialsBySession.map((s, num) => (
                            <button
                              key={num}
                              onClick={() => setSelectedFolder(s.MaterialsList)}
                              className="p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-200 text-left"
                            >
                              <div className="flex items-center space-x-3">
                                <i className="fas fa-folder text-[#FFB800] text-xl"></i>
                                <span className="font-medium text-gray-900">
                                  {s.FolderName}
                                </span>
                              </div>
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        )}
      </div>
    </MasterPage>
  );
};
